var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('custom-select',{attrs:{"label":"Actividad","value":_vm.value,"name":"actividad-sujeto-obligado","items":_vm.actividades,"required":_vm.required,"analyticsTypology":_vm.config.analyticsTypology,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }